export enum LoanTypeEnum {
  temporary_loan = 'T',
  no_loan = 'N',
  bank_loan = 'B',
  hdb_loan = 'H',
}
